import { render } from "./BracketItemMatchNull.vue?vue&type=template&id=6d851187&ts=true"
import script from "./BracketItemMatchNull.vue?vue&type=script&lang=ts"
export * from "./BracketItemMatchNull.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__